import React from 'react';
import '../styles/Bio.css';
import MyCarousel from '../MyCarousel';

const Bio = ({ bioData }) => {
    React.useEffect(() => {
        document.title = bioData.title;
    }, [bioData.title]);

    const renderBasicInfo = (personalInfo) => (
        <div className="bio-section">
            <h2 className="section-title">Basic Information</h2>
            <div className="basic-info">
                {Object.values(personalInfo).map((value, index) => (
                    <div className="info-item" key={index}>
                        <span className="info-value">{value}</span>
                    </div>
                ))}
            </div>
        </div>
    );

    const renderObjectContent = (section) => {
        if (Array.isArray(section.content)) {
            return (
                <ul>
                    {section.content.map((value, index) => (
                        <li key={index}>{value}</li>
                    ))}
                </ul>
            );
        } else if (typeof section.content === 'object') {
            return (
                <div>
                    {Object.entries(section.content).map(([key, value], index) => (
                        <div key={index} className="nested-content">
                            <h3 className="nested-title">{key.replace('_', ' ')}</h3>
                            {Object.entries(value).map(([subKey, subValue], subIndex) => (
                                <p key={subIndex}>{subValue}</p>
                            ))}
                        </div>
                    ))}
                </div>
            );
        }
    };

    return (
        <div className="floating-container">
            {bioData && (
                <div className="bio-info">
                    <h1 className="bio-title">Academic/Extracurricular Bio</h1>
                    <div style={{ maxWidth: '100%' }} className="image-container">
                        <MyCarousel images={bioData.carousel_images} />
                    </div>
                    {bioData.bio_sections.map((section, index) => {
                        if (section.section_title === 'Basic Information') {
                            return renderBasicInfo(section.content.personal_info);
                        } else {
                            return (
                                <div className="bio-section" key={index}>
                                    <h2 className="section-title">{section.section_title}</h2>
                                    {renderObjectContent(section)}
                                </div>
                            );
                        }
                    })}
                </div>
            )}
        </div>
    );
};

export default Bio;
